import VocResult from "./VocResult";

const Fugitive = () => {
  return <VocResult />;
};

export default Fugitive;
